import { Transform } from 'class-transformer';
import { IsInt, IsNumber, IsOptional, IsString, Min } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class TransportDocumentItemDto {
  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  lotId?: string;

  // Optional when lotId is set: the backend defaults it from the lot's name.
  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string;

  @IsNumber()
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  quantity!: number;

  // Optional when lotId is set: the backend defaults it from the lot's measurementUnit.
  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  unit?: string;

  @IsInt()
  @IsOptional()
  @Min(0)
  sortOrder?: number;
}
